import { render, staticRenderFns } from "./PetitionBanner.vue?vue&type=template&id=7e15121b&"
import script from "./PetitionBanner.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PetitionBanner.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e15121b')) {
      api.createRecord('7e15121b', component.options)
    } else {
      api.reload('7e15121b', component.options)
    }
    module.hot.accept("./PetitionBanner.vue?vue&type=template&id=7e15121b&", function () {
      api.rerender('7e15121b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PetitionBanner/PetitionBanner.vue"
export default component.exports